import { Latitude, Longitude } from './GIS';
export { Latitude, Longitude };
